'use client'

import { Button, Icon } from '@vinted/web-ui'
import { ArrowLeft24, ArrowRight24 } from '@vinted/monochrome-icons'

import {
  HideAtBreakpoint,
  ShowAtBreakpoint,
} from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  InfluencerClosetModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'

import SliderWrapper from '../../../../components/SliderWrapper/SliderWrapper'
import ProductCard from '../ProductCard'

type Props = { data: InfluencerClosetModel }

export const ClosetSection = ({ data: { title, productList, ctaText, ctaUrl } }: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.FollowClosetCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="closet-section" className="influencer__closet-section">
      <h2 className="influencer__closet-title">{title}</h2>
      <HideAtBreakpoint breakpoint="wide">
        <div className="influencer__closet-cards-wrapper">
          <SliderWrapper
            childData={productList
              .filter(card => card !== null)
              .map(
                (card, index) =>
                  ({
                    testId: `closet-section-card-${index}`,
                    ...card,
                  }) as React.ComponentProps<typeof ProductCard>,
              )}
            childComponent={ProductCard}
            nextButton={<Icon name={ArrowRight24} />}
            previousButton={<Icon name={ArrowLeft24} />}
          />
        </div>
      </HideAtBreakpoint>
      <ShowAtBreakpoint breakpoint="wide">
        <div className="influencer__closet-cards-wrapper">
          {productList.map((props, index) => {
            if (!props) return null

            return <ProductCard {...props} key={index} testId={`closet-section-card-${index}`} />
          })}
        </div>
      </ShowAtBreakpoint>
      <div className="influencer__closet-cta-wrapper">
        <div className="influencer__closet-cta">
          <Button
            styling={Button.Styling.Filled}
            text={ctaText}
            testId="closet-section-cta"
            onClick={handleOnCtaClick}
            url={ctaUrl}
          />
        </div>
      </div>
    </section>
  )
}
